export default __webpack_public_path__ + "static/media/regional-center-logo.6ff2c7d8.svg";